import _ from 'lodash';

import { commonErrors } from '@zapier/toolbox-redux-framework/src/error';
import { ensureArray } from '@zapier/common-utils';

import * as statuses from './statuses';

const errorMap = {
  GET: commonErrors.DataGetError,
  POST: commonErrors.DataPostError,
  PATCH: commonErrors.DataPatchError,
  DELETE: commonErrors.DataDeleteError,
};

const extractErrorsFromResponse = response => {
  try {
    const { errors } = JSON.parse(_.get(response, 'responseText'));
    return ensureArray(errors);
  } catch (e) {
    return undefined;
  }
};

const createError = (method, resource, response) =>
  new errorMap[method.toUpperCase()]({ resource, response });

// `error` may be an actual error, like an error when trying to parse
// JSON or possibly some sort of code execution error, but it will
// often be a `Response` object that was thrown from `fetch`. This
// function normalizes all of the errors into a string or the `statusMessage`
// of an entity or collection.
const normalizeFetchError = (method, entityType, messages, error) => {
  const responseErrors = extractErrorsFromResponse(error);
  const defaultError = (_.isError(error)
    ? error
    : createError(method, entityType, error)
  ).toString();
  return {
    messages: responseErrors || _.get(messages, 'failure') || defaultError,
    status: statuses.FAILURE,
    statusCode: error.status,
  };
};

export default normalizeFetchError;

export const normalizeGetError = _.partial(normalizeFetchError, 'GET');
export const normalizePostError = _.partial(normalizeFetchError, 'POST');
export const normalizePatchError = _.partial(normalizeFetchError, 'PATCH');
export const normalizeDeleteError = _.partial(normalizeFetchError, 'DELETE');
